import { Trans } from '@lingui/react'

import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ButtonSmall from 'views/components/molecules/ButtonSmall'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

export const closeComponentForModal = () => (
  <>
    <ButtonSmall
      name="modal-close-button"
      href="#"
      primary
      data-clientside-hook="hitsPerPage__close-modal"
      ariaHidden="true"
    >
      <TextWithIcon
        icon={<IconCross className="o-HitsPerPageMobile__close-button__icon" />}
      >
        <span className="u-visuallyhidden">
          <Trans id="general.link.label.close" />
        </span>
      </TextWithIcon>
    </ButtonSmall>
    <ButtonAsLink
      name="modal-cancel-selection"
      href="#"
      data-clientside-hook="hitsPerPage__cancel-selection"
      ariaHidden="true"
    >
      <Trans id="general.link.label.back" />
    </ButtonAsLink>
  </>
)
